<template>
  <v-dialog :value="value" persistent fullscreen>
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="$emit('input', false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title primary-title class="primary toolbar-dense">
          <span class="white--text">Informe Delegado</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-skeleton-loader
            v-if="loading"
            ref="skeleton"
            type="table-heading, list-item-two-line, image, table-tfoot"
            class="mx-auto"
          />
          <v-form v-else ref="form" v-model="form">
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    Delegado
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="10" class="pt-2">
                        <v-text-field
                          v-model.trim="delegado.identificacion" label="Rut" dense
                          type="Number"
                          hint="Ingrese sin guión ni punto y sin dígito verificador"
                          :rules="[$chkRequiredField('Identificación')]"
                          class="my-upper"
                        />
                      </v-col>
                      <v-col cols="12" sm="2" class="pt-2">
                        <v-btn color="secondary" :disabled="!runValido" :loading="loadNombre" @click="getNombrePersona(delegado.identificacion)">
                          Buscar <v-icon>search</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" class="pt-2">
                        <v-text-field v-model="delegado.nombreCompleto" label="Nombre" dense disabled class="my-upper" :rules="[$chkRequiredField('Nombre')]" />
                      </v-col>
                      <v-col cols="12" class="pt-2">
                        <v-text-field
                          v-model="delegado.procedencia" label="Universidad, facultad, establecimiento educacional, servicio o secretaría de admisión a la que
                          pertenece" dense :rules="[$chkRequiredField('Procedencia')]" class="my-upper"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>Problemas presentados</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        Problemas relevantes presentados en el desarrollo de la aplicación tales como manifestaciones,
                        suspensión de prueba, postulantes sorprendidos hurtando, rompiendo, fotografiando y/o quemando
                        material de aplicación o
                        algún problema con miembro(s) del equipo de aplicación referente a un hecho que puso en riesgo el
                        desarrollo de la aplicación y/o la confidencialidad de las pruebas. Si se postulantes o miembros
                        del
                        equipo de aplicación
                        se solicita mencionar el run y nombre de la persona. ( Cualquier información indicada en este
                        punto
                        también debe quedar consignada en el acta de aplicación)
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        <v-textarea
                          v-model="problemas" name="input-7-4" label="Indique problemas presentados"
                          :rules="!!problemas ? [minimo(10), maximo(4000)] : []"
                          counter="4000" maxlength="4000" auto-grow
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    Calidad de la información y apoyo otorgado por DEMRE
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        <v-radio-group
                          ref="calidad"
                          v-model="calidad.codigo"
                          :rules="[$chkRequiredField('Calidad de la información y apoyo otorgado por DEMRE')]" row
                        >
                          <v-radio
                            v-for="(item, key) in valoresEvaluacion"
                            ref="fundamentoCalidad"
                            :key="key" :label="item.text"
                            :value="item.value"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        <v-textarea
                          v-model="calidad.fundamento" name="input-7-4" label="Fundamente su selección"
                          :rules="[$chkRequiredField('Fundamente su selección'), minimo(10), maximo(5000)]" counter="5000"
                          maxlength="5000" auto-grow
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    Personal Destacado
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        Individualizar personal destacado que pudiera desempeñar funciones de mayor responsabilidad en
                        futuros
                        procesos
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" class="pt-2">
                        <v-select
                          v-model="local"
                          :items="locales" item-value="lapCodigo" item-text="local.nombre"
                          label="Seleccionar Local" persistent-hint return-object single-line
                        />
                      </v-col>
                      <v-col cols="12" sm="6" class="pt-2">
                        <v-select
                          v-model="seleccion"
                          :hint="`${seleccion.identificacion ? seleccion.identificacion +' , ' + seleccion.funcion.nombre : ''}`"
                          :items="personalNoSeleccionado" item-value="nroIdentificacion" item-text="nombreCompleto"
                          label="Seleccionar Personal" persistent-hint return-object single-line
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="!!seleccion.identificacion">
                      <v-col class="mt-2 pb-0">
                        <v-textarea
                          v-model="fundamento" name="input-7-4" label="Fundamente su selección"
                          :rules="!!seleccion && !!fundamento ? [$chkRequiredField('Fundamente su selección'), minimo(10), maximo(4000)] : []"
                          counter="4000" maxlength="4000" auto-grow
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pt-0 d-flex justify-center">
                        <v-btn color="secondary" :disabled="seleccion.identificacion && fundamento? false : true " @click="agregaDestacado">
                          Agregar<v-icon right>
                            $account_plus
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        <v-data-table
                          :headers="headers" :items="personal.destacados"
                          no-data-text="Sin personal desatacado"
                        >
                          <template #item.eliminar="{ item }">
                            <v-btn color="red" fab x-small dark @click.native="mostrarDialogEliminar(item)">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    Transporte
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        Indique todo tipo de información que facilite el traslado hacia la sede y la estadía en ella.
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="mt-2 pb-0">
                        <v-textarea
                          ref="transporte"
                          v-model="transporte" name="input-7-4" label="Fundamente"
                          :rules="[$chkRequiredField('Fundamente'), minimo(10), maximo(5000)]" counter="4000"
                          maxlength="4000" auto-grow
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0">
                        <strong>Alojamiento: Hoteles o Residenciales</strong>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-left">
                                Nombre
                              </th>
                              <th class="text-left">
                                Dirección
                              </th>
                              <th class="text-left">
                                Teléfono
                              </th>
                              <th class="text-left">
                                Valor diario
                              </th>
                              <th class="text-left">
                                Calidad del servicio
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <v-text-field
                                  v-model="hotel.nombre"
                                />
                              </td>
                              <td>
                                <v-text-field
                                  v-model="hotel.direccion"
                                />
                              </td>
                              <td>
                                <v-text-field
                                  v-model="hotel.telefono"
                                  maxlength="9"
                                  type="tel"
                                  :rules="[limitLength(9)]"
                                  hide-spin-buttons
                                />
                              </td>
                              <td>
                                <v-text-field
                                  v-model="hotel.valor"
                                  type="number"
                                  prefix="$"
                                />
                              </td>
                              <td>
                                <v-select
                                  v-model="hotel.calidad"
                                  :items="valoresEvaluacion"
                                />
                              </td>
                              <td>
                                <v-btn color="secondary" :disabled="!(hotel.nombre && hotel.direccion && hotel.telefono && hotel.valor && hotel.calidad)" @click="agregarHotel">
                                  <v-icon>add</v-icon> Agregar
                                </v-btn>
                              </td>
                            </tr>
                            <tr v-for="item in hoteles" :key="item.nombre">
                              <td>
                                {{ item.nombre }}
                              </td>
                              <td>
                                {{ item.direccion }}
                              </td>
                              <td>
                                {{ item.telefono }}
                              </td>
                              <td>
                                ${{ item.valor }}
                              </td>
                              <td>
                                {{ getValorEvaluacion(item.calidad) }}
                              </td>
                              <td>
                                <v-btn color="red" fab x-small dark @click.native="confirmarEliminarHotel(item)">
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <d-confirm v-model="confirmarEliminarDialog.model" :max-width="500">
              <template #title>
                Eliminar Examinador
              </template>
              {{ confirmarEliminarDialog.msg }}
              <template #refuse-btn>
                <v-btn color="primary" :loading="loadingEliminar" @click="eliminarDestacado">
                  SI
                </v-btn>
              </template>
              <template #accept-btn>
                <v-btn color="secondary" @click="confirmarEliminarDialog.model = false">
                  NO
                </v-btn>
              </template>
            </d-confirm>
            <d-confirm v-model="dialogEliminarHotel" :max-width="500">
              ¿Estas seguro que desas eliminar este Alojamiento?
              <template #refuse-btn>
                <v-btn color="primary" :loading="loadingEliminar" @click="eliminarHotel">
                  SI
                </v-btn>
              </template>
              <template #accept-btn>
                <v-btn color="secondary" @click="dialogEliminarHotel = false">
                  NO
                </v-btn>
              </template>
            </d-confirm>
          </v-form>
          <v-card-actions v-if="!loading" class="d-flex justify-space-around">
            <v-btn color="success" :loading="loading" @click="save">
              {{ update ? 'Actualizar' :'Ingresar' }}
            </v-btn>
            <v-btn color="secondary" @click="$emit('input', false)">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  import graphql from '../../utils/graphql';
  import { formatoRut, nombreCompletoApellidosPrimero } from '../../utils/utils';
  import ConfirmDialog from '../common/ConfirmDialog';

  export default {
  components: {
    'd-confirm': ConfirmDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sede: {
      type: Number,
      default: null
    },
    fase: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    form:false,
    nominaPersonal: [],
    delegado: {
      identificacion: null,
      procedencia: '',
      nombreCompleto: ''
    },
    local: null,
    hoteles: [],
    hotel: {
      nombre: '',
      direccion: '',
      telefono: null,
      valor: null,
      calidad: null,
    },
    seleccion: {},
    fundamento: null,
    problemas: '',
    calidad: {
      codigo: null,
      fundamento: null,
    },
    personal: {
      destacados: []
    },
    transporte: null,
    loading: false,
    confirmarEliminarDialog: {
      model: false,
      msg: '',
    },
    dialogEliminarHotel: false,
    loadingEliminar: false,
    update: false,
    eliminado: null,
    loadNombre: false,
  }),
  computed: {
    runValido() {
      return this.delegado.identificacion ? this.delegado.identificacion.length > 7 : false;
    },
    headers: function () {
      const item = [
        { text: 'Identificación', value: 'identificacion', sortable: false, class: 'blue-grey lighten-4' },
        { text: 'Nombre', value: 'nombreCompleto', sortable: false, class: 'blue-grey lighten-4' },
        { text: 'Función', value: 'funcion.nombre', sortable: false, class: 'blue-grey lighten-4' },
        { text: 'Fundamento', value: 'fundamento', sortable: false, class: 'blue-grey lighten-4' },
        { text: 'Eliminar', value:'eliminar', align: 'center', sortable: false, class: 'blue-grey lighten-4' }
      ];
      return item;
    },
    locales() {
      return window.DATA.locales;
    },
    personalNoSeleccionado() {
      return this.local ? this.nominaPersonal.filter(e => !this.personal.destacados.some(p => p.nroIdentificacion == e.nroIdentificacion) && e.local.codigo == this.local.lapCodigo) : [];
    },
    valoresEvaluacion() {
      const evaluacion = [
        {
          value: 1,
          text: "Excelente"
        },
        {
          value: 2,
          text: "Bueno"
        },
        {
          value: 3,
          text: "Suficiente"
        },
        {
          value: 4,
          text: "Deficiente"
        },
      ];
      return evaluacion;
    }
  },
  watch: {
    local() {
     this.seleccion = {};
    }
  },
  async mounted() {
    await this.cargaDatos();
  },
  methods: {
    getValorEvaluacion(valor) {
      return this.valoresEvaluacion.find(e => e.value == valor).text;
    },
    agregaDestacado() {
      const persona = Object.assign({}, this.seleccion);
      persona.fundamento = this.fundamento;
      this.personal.destacados.push(persona);
      this.seleccion = {};
      this.fundamento = null;
    },
    agregarHotel() {
        this.hoteles.push(this.hotel);
        this.hotel = {};
    },
    mostrarDialogEliminar(item) {
      this.confirmarEliminarDialog.msg = `¿Está seguro de eliminar al examinador ${item.nombreCompleto}?`;
      this.confirmarEliminarDialog.model = true;
      this.eliminado = item;
    },
    eliminarDestacado() {
      this.personal.destacados = this.personal.destacados.filter(e => e.nroIdentificacion !== this.eliminado.nroIdentificacion);
      this.loadingEliminar = false;
      this.confirmarEliminarDialog.model = false;
    },
    confirmarEliminarHotel(item) {
      this.dialogEliminarHotel = true;
      this.loadingEliminar = false;
      this.eliminado = item;
    },
    eliminarHotel() {
      this.loadingEliminar = true;
      this.hoteles = this.hoteles.filter(h => !this.shallowEqual(h,this.eliminado));
      this.loadingEliminar = false;
      this.dialogEliminarHotel = false;
    },
    shallowEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);
      if (keys1.length !== keys2.length) {
        return false;
      }
      for (let key of keys1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }
      return true;
    },
    minimo: minimo => v => v && v.length > minimo || `El mínimo de caracteres ingresados son ${minimo}`,
    maximo: maximo => v => v && v.length < maximo || `El máximo de caracteres ingresados son ${maximo}`,
    limitLength: limit => number => {
      const cond = !number || String(number).length == limit;
      return cond || `Debe tener un largo de ${limit} dígitos`;
    },
    async cargaDatos() {
      this.loading = true;
      const sedes = [];
      if (this.locales) {
        this.locales.forEach(local => {
          sedes.push(local.sedCodigo); //sedes CCP
        })
      }
      try {
        const query = {
          query: `
            query GetInforme($fspCodigo: Int!, $sedCodigo: Int!, $sedes: [Int!]!, $funciones: [Int!]!) {
              informe: readInformeDelegado(fspCodigo: $fspCodigo, sedCodigo: $sedCodigo){
                fspCodigo
                sedCodigo
                identificacion
                procedencia
                problemas
                calidadInfoDEMRE
                fundamentoCalidad
                fundamentoTransporte
                destacados {
                    fspCodigo
                    sedCodigo
                    destacadoTipoIdentificacion
                    destacadoNroIdentificacion
                    fundamento
                  }
                hoteles {
                  nombre
                  direccion
                  telefono
                  valor
                  calidad
                }
              }
              nomina: personalBySedeFaseFuncion(fspCodigo: $fspCodigo, sedes: $sedes, funciones: $funciones){
                fneCodigo
                tipoIdentificacion
                nroIdentificacion
                persona {
                  tipoIdentificacion
                  numeroIdentificacion
                  dv
                  paterno
                  materno
                  nombres
                }
                funcion {
                  nombre
                }
                local {
                  codigo
                }
              }
            }
          `,
          variables: {
            fspCodigo: this.fase,
            sedCodigo: this.sede,
            sedes,
            funciones: [2, 3], //jefe de local, coordinador
          }
        };
        let { informe, nomina } = await graphql.request(query);
        nomina = nomina.filter(e => {
          e.identificacion = formatoRut(e.persona);
          e.nombreCompleto = nombreCompletoApellidosPrimero(e.persona);
            return e;
        });
        nomina.sort((a, b) => {
          if (a.nombreCompleto > b.nombreCompleto) {
            return 1;
          }
          return -1;
        });
        this.nominaPersonal = nomina;
        if (informe) {
          this.problemas = informe.problemas;
          this.calidad.codigo = informe.calidadInfoDEMRE;
          this.calidad.fundamento = informe.fundamentoCalidad;
          this.personal.destacados = [];
          this.transporte = informe.fundamentoTransporte;
          this.delegado.identificacion = informe.identificacion;
          this.delegado.procedencia = informe.procedencia;
          informe.identificacion ? this.getNombrePersona(informe.identificacion) : '';

          if (informe.destacados && informe.destacados.length > 0) {
            informe.destacados.forEach(p => {
              const persona = this.nominaPersonal.find(e => p.destacadoNroIdentificacion == e.nroIdentificacion);
              persona.fundamento = p.fundamento;
              this.personal.destacados.push(persona);
            });
          }
          if(informe.hoteles && informe.hoteles.length > 0) {
            this.hoteles = informe.hoteles;
          }
          this.update = true;
        }
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loading = false;
    },

    async getNombrePersona(numero) {
      this.loadNombre = true;
      try {
        const query = {
          query: `
            query GetPersona($tipo: String!, $numero: Int!) {
              persona: readPersona(tipo: $tipo, numero: $numero){
                paterno
                materno
                nombres
              }
            }
          `,
          variables: {
            tipo: 'C',
            numero,
          }
        };
        const { persona } = await graphql.request(query);
          this.delegado.nombreCompleto = persona ? nombreCompletoApellidosPrimero(persona) : '';
        this.loadNombre = false;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
    },

    async save() {
      if (!this.form) {
        this.$refs.form.validate();
        this.$store.commit('error-notification', 'Debe completar el formulario antes de guardar');
        return false;
      }
      this.loading = true;
      try {
        if(!this.delegado?.identificacion) {
          throw new Error ('Delegado sin identificación');
        }
        const personal = this.personal.destacados.map(({tipoIdentificacion, nroIdentificacion, fundamento}) => ({
          destacadoTipoIdentificacion:tipoIdentificacion, destacadoNroIdentificacion:nroIdentificacion, fspCodigo:this.fase, sedCodigo:this.sede, username: '', fundamento
          }));
          const hoteles = this.hoteles.map(h => ({
            ...h, fspCodigo: this.fase, sedCodigo: this.sede, username: ''
          }));
        const query = {
          query: `
            mutation ($informe: app_InformeDelegadoInput!, $destacados: [app_PersonalDestacadoDelegadoInput], $hoteles: [app_HotelDelegadoInput]) {
              done: insertInformeDelegado(informe: $informe, destacados: $destacados, hoteles: $hoteles)
            }
          `,
          variables: {
            informe: {
              fspCodigo: this.fase,
              sedCodigo: this.sede,
              username: '',
              problemas:this.problemas,
              calidadInfoDEMRE: this.calidad.codigo,
              fundamentoCalidad: this.calidad.fundamento,
              fundamentoTransporte: this.transporte,
              identificacion: this.delegado.identificacion,
              procedencia: this.delegado.procedencia,
            },
            destacados: personal,
            hoteles,
          }
        };
        const { done } = await graphql.request(query);
        if (!done) {
          throw new Error('No se pudo guardar el informe');
        }
        this.$store.commit('success-notification', `Informe de Delegado guardado correctamente`);
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
      this.loading = false;
    }
  }

}
</script>
